import { ChevronRight } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useUIStore } from '../../store/uiStore';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface TopBarProps {
  breadcrumbs?: BreadcrumbItem[];
}

export function TopBar({ breadcrumbs = [] }: TopBarProps) {
  const { user } = useAuth();
  const { sidebarPinned } = useUIStore();

  const sidebarWidth = sidebarPinned ? 'var(--sidebar-expanded)' : 'var(--sidebar-collapsed)';

  return (
    <header
      className="fixed top-0 right-0 z-20 flex items-center transition-all duration-200"
      style={{
        left: sidebarWidth,
        height: 'var(--topbar-height)',
        background: 'var(--surface-base)',
        borderBottom: '1px solid var(--border-subtle)',
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
    >
      {/* Breadcrumb */}
      <nav className="flex items-center gap-1 flex-1 min-w-0">
        {breadcrumbs.length === 0 ? (
          <span className="text-[13px]" style={{ color: 'var(--text-secondary)' }}>
            Webtoon MOS
          </span>
        ) : (
          breadcrumbs.map((crumb, idx) => (
            <span key={idx} className="flex items-center gap-1 min-w-0">
              {idx > 0 && (
                <ChevronRight className="w-3 h-3 shrink-0" style={{ color: 'var(--text-tertiary)' }} />
              )}
              <span
                className="text-[13px] truncate"
                style={{
                  color: idx === breadcrumbs.length - 1 ? 'var(--text-primary)' : 'var(--text-secondary)',
                  fontWeight: idx === breadcrumbs.length - 1 ? 500 : 400,
                }}
              >
                {crumb.label}
              </span>
            </span>
          ))
        )}
      </nav>

      {/* Right actions */}
      <div className="flex items-center gap-2 shrink-0">
        {/* User avatar */}
        <div className="flex items-center gap-2">
          <div
            className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold"
            style={{ background: 'var(--accent-primary)', color: 'var(--surface-base)' }}
          >
            {user?.name?.charAt(0).toUpperCase() ?? 'U'}
          </div>
          <span className="text-[13px] font-medium hidden sm:block" style={{ color: 'var(--text-primary)' }}>
            {user?.name ?? user?.email}
          </span>
        </div>
      </div>
    </header>
  );
}
